import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { SaveBlocker, saveBlockerHref } from "./saveBlocker";

/**
 * Shows the row a save was refused for (PREC-4987): on the page that lists it, the `?focus=` link
 * selects and flashes it. On another step the message alone names it — leaving the page would leave
 * the unsaved draft behind.
 */
export const useSaveBlockerFocus = (blocker: SaveBlocker | null): void => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	useEffect(() => {
		if (!blocker) {
			return;
		}

		const href = saveBlockerHref(blocker);

		if (href.split("?")[0] === pathname) {
			navigate(href, { replace: true });
		}
	}, [blocker]);
};
